<template>
  <div id="login" class="card">
    <div class="card-body">
      <div v-if="loginError" class="alert alert-danger">Usuario o contraseña incorrectos</div>
      <div class="text-center mb-4 mt-1">
        <img alt="Vue logo" height="60" src="../../../assets/logo-rentik.svg">
      </div>
      <form @submit.prevent="submit()">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="user">Usuario</label>
              <input type="text" class="form-control" id="user" v-model.trim="v$.user.$model">
              <div v-if="v$.user.$dirty">
                <small class="form-text text-danger" v-if="!v$.user.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input type="password" class="form-control" id="password" v-model.trim="v$.password.$model">
              <div v-if="v$.password.$dirty">
                <small class="form-text text-danger" v-if="!v$.password.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button class="btn btn-primary btn-login" v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid">
              <span v-if="!loading">Iniciar sesión</span>
              <img v-if="loading" src="../../../assets/loader.svg" height="20" alt="">
            </button>
            <router-link class="nav-link px-1 mt-3" :to="{ name: 'getOtp' }">He olvidado mi contraseña</router-link>
            <small class="text-muted mt-2 d-block" style="font-size: 0.75rem;">{{ $siteVersion }}</small>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: 'Login',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      user: '',
      password: '',
      loginError: false,
      loading: false,
    };
  },

  validations() {
    return {
      user: {
        required
      },
      password: {
        required
      },
    }
  },

  methods: {

    submit() {
      this.loading = true;
      const bodyToSend = {
        username: this.user,
        password: this.password,
        userType: "BACKOFFICE"
      }
      axios.post('/user/login', bodyToSend)
        .then((response) => {
          if (response.data.distributor) this.$cookies.set('distributor', response.data.distributor);
          if (response.data.store) this.$cookies.set('store', response.data.store);
          this.$cookies.set('token', response.data.credentials.accessToken, response.data.credentials.expiresIn + 's');
          this.$cookies.set('username', this.user);
          this.$cookies.set('refreshToken', response.data.credentials.refreshToken, response.data.credentials.expiresIn + 's');
          axios.get('/user/getUser')
            .then((response) => {
              this.$cookies.set('tenant', response.data.tenant);
              this.$cookies.set('store', response.data.storeNumber);
              this.$cookies.set('channel', response.data.channel);
              let roles = [];
              if (response.data.roles != undefined && response.data.roles != null && Array.isArray(response.data.roles) && response.data.roles.length > 0) {
                response.data.roles.forEach(element => {
                  roles.push(element.role);
                });
                
              } else {
                roles.push('sinRol');
              }
              this.$store.commit("setRoles", roles);
              this.$router.push({ name: 'newContractStep1' })
              this.loading = false;
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          if (error.response.data.status == 'NEW_PASSWORD_REQUIRED' || error.response.data.status == 'PASSWORD_RESET_REQUIRED') {
            this.$router.push({ name: 'updatePassword' })
            this.loading = false;
          }
          else if (error.response.data.status == 'PASSWORD_RESET_REQUIRED') {
            this.$router.push({ name: 'getOtp' })
            this.loading = false;
          }
          else if (error.response.data.status == 'BAD_CREDENTIALS') {
            this.loginError = true;
            this.loading = false;
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btn-login {
  min-width: 120px;
}
</style>
